import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from "../components/auth.vue"
import personCenter from "../components/personCenter.vue"
import petList from "../components/petList.vue"
import petDetail from "../components/petDetail.vue"
import apply from "../components/apply.vue"
import petEdit from "../components/petEdit.vue"
Vue.use(VueRouter)
let router = new VueRouter({
    mode: 'history', // 去掉url中的#
    routes : [
        {
            path : '/',
            component : auth
        },
        {
            path : '/personCenter',
            component : personCenter
        },
        {
            path : '/auth',
            component : auth
        },
        {
            path : '/petList',
            component : petList
        },
        {
            path : '/petDetail',
            component : petDetail
        },
        {
            path : '/apply',
            component : apply
        },
        {
            path : '/petEdit',
            component : petEdit
        }
    ]
})
// router.beforeEach((to,from,next)=>{
//     if(!sessionStorage.getItem("TC_PET_USERDATA")&&to.path!="/auth"){
//         next("/auth")
//     }else(
//         next()
//     )
// })

export default router